
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Options, Vue } from 'vue-class-component';
import { store } from './store';
import { IContact } from './models/store/contacts/contact.model';
import { isEqual } from 'lodash';
import { environment } from './assets/environment';
import { ISnackbarState } from './models/store/snackbar/snackbar.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import FormModal from './components/modals/FormModal.vue';
import { service } from './services/service';
import { ContactType } from './models/store/contacts/contact-type.model';
import router from './router';
import { downloadTermsOfAgreementHref } from '../src/assets/constants/terms-of-agreement';
import { BUCKET_LABEL, SIGN_IN_LABEL } from './constants/labels';
import AdditionalModal from './components/modals/AdditionalModal.vue';
import { storageService } from './services/storage';
import { Watch } from 'vue-property-decorator';
import { DecodedToken } from './models/store/auth/decoded-token.model';
import { orderService } from './services/entities-service/orders-service/orders.service';
import { AccountMenuItem } from './models/personal/account-menu-items.model';
import { personalData } from './constants/personal';

@Options({
    components: {
        FormModal,
        AdditionalModal,
    },
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class App extends Vue {
    activeTab = '';
    timeout = 4000;
    vertical = false;
    drawer = false;
    isHiddenSecondMenuContainer = false;
    isSign = false;
    accountMenuModel = false;
    bucketLabel = BUCKET_LABEL;
    signIconsObject = {
        signIn: 'mdi-account-circle-outline',
        signOut: 'mdi-login',
    };
    accountMenuItems: AccountMenuItem[] = personalData.accountMenuItems;
    otherGoodsItems: { title: string }[] = [
        { title: 'Центровочные кольца' },
        { title: 'Болты и гайки' },
        { title: 'Автокейсы' },
        { title: 'Автоковрики' },
    ];

    catalogItems: { title: string }[] = [
        { title: 'Шины легковые' },
        { title: 'Шины грузовые' },
        { title: 'Диски' },
        { title: 'АКБ' },
        { title: 'Центровочные кольца' },
        { title: 'Болты и гайки' },
        { title: 'Автокейсы' },
        { title: 'Автоковрики' },
    ];

    matsItems: { title: string }[] = [
        { title: 'Автокейсы' },
        { title: 'Ворсовые коврики' },
        { title: 'ЭВА-автоковрики' },
        { title: 'ЭВА в лодку' },
        { title: 'Автошторки' },
    ];

    buyerItems: { title: string }[] = [
        { title: 'Как купить' },
        { title: 'Доставка' },
        { title: 'Бонусы' },
        { title: 'Гарантия' },
        { title: 'Рассрочка' },
    ];

    mobileTabs: { title: string; value: string; isMain: boolean }[] = [
        { title: 'Главная', value: 'main', isMain: false },
        { title: 'Шины легковые', value: 'tires', isMain: true },
        { title: 'Шины грузовые', value: 'cargo', isMain: true },
        { title: 'Диски', value: 'wheels', isMain: true },
        { title: 'АКБ', value: 'batteries', isMain: false },
        { title: 'Центровочные кольца', value: 'rings', isMain: false },
        { title: 'Болты и гайки', value: 'screw', isMain: false },
        // { title: 'Гайка', value: '', isMain: false },
        { title: 'Автоковрики', value: 'carMats', isMain: false },
        { title: 'Автокейсы', value: 'autoBags', isMain: false },
        // { title: 'Ворсовые коврики', value: 'pileMats', isMain: false },
        // { title: 'ЭВА-автоковрики', value: 'evaMats', isMain: false },
        // { title: 'ЭВА в лодку', value: 'boatMats', isMain: false },
        // { title: 'Автошторки', value: 'autoShutter', isMain: false },
        { title: 'Как купить', value: 'howBuy', isMain: false },
        { title: 'Доставка', value: 'delivery', isMain: false },
        { title: 'Бонусы', value: 'bonuses', isMain: false },
        { title: 'Гарантия', value: 'guarantee', isMain: false },
        { title: 'Рассрочка', value: 'installment', isMain: false },
        { title: 'О нас', value: 'about', isMain: false },
        {
            title: 'Договор публичной оферты и Политика обработки персональных данных',
            value: 'termsAgreement',
            isMain: false,
        },
    ];

    created() {
        store.dispatch('changeIsMobile', window.innerWidth < 781);
        store.dispatch('getContacts');
        store.dispatch('getSale');
        store.dispatch('fetchInstallments', 0);
        store.dispatch('getClientOrders', {});
        this.tokenObserver();
    }

    get storageToken(): string {
        return store.getters.getStoreToken;
    }

    get userEmail(): string {
        return store.getters.getUserEmail;
    }

    get signStatusIcon(): string {
        return this.isSign ? this.signIconsObject['signIn'] : this.signIconsObject['signOut'];
    }

    get support(): IContact {
        return store.getters.getSupport;
    }

    get snackbar(): ISnackbarState {
        return store.getters.getSnackbarState;
    }

    get snackbarColor(): string {
        return '';
    }

    get environment(): string {
        return environment.baseUrl;
    }

    get isMobile(): boolean {
        return store.getters.getIsMobile;
    }

    get contacts(): IContact[] {
        return store.getters.getContacts;
    }

    get contactsPhone(): IContact[] {
        return store.getters.getContacts.filter((item: IContact) => isEqual(item.type, 'phone'));
    }

    get accountLabel(): string {
        return this.isSign ? this.userEmail : SIGN_IN_LABEL;
    }

    get countOrders(): number {
        return store.getters.getBucketOrders.at(0)?.goods?.length || 0;
    }

    get isUnAuthorized(): boolean {
        return store.getters.getIsUnAuth;
    }

    handleClick(isBucket: boolean): void {
        if (isBucket) router.push({ path: '/bucket' });
        else {
            if (this.isSign) {
                console.log('');
            } else {
                store.dispatch('changeAdditionalModal', {
                    status: true,
                    data: { sign: 'signUp', isMobile: this.isMobile },
                });
            }
        }
    }

    handleLink(item: IContact): void {
        if (isEqual(item.type, 'support')) {
            store.dispatch('changeFormModal', { status: true, data: {}, isSupport: true });

            return;
        } else if (!this.isMobile && isEqual(item.type, 'phone')) {
            store.dispatch('changeSnackbar', {
                status: true,
                text: 'Заполните форму, с Вами свяжется наш менеджер',
                isError: false,
            });
            store.dispatch('changeFormModal', { status: true, data: {} });
            return;
        }
        window.open(service.returnHref(item.type as ContactType, item.contact));
    }

    handleMenuItem(index: number): void {
        switch (true) {
            case isEqual(index, 0):
                router.push({ path: '/tires-view' });
                break;

            case isEqual(index, 1):
                router.push({ path: '/wheel-disks' });
                break;

            case isEqual(index, 2):
                router.push({ path: '/accumulator-batteries' });
                break;

            case isEqual(index, 3):
                router.push({ path: '/auto-mats' });
                break;

            case isEqual(index, 4):
                router.push({ path: '/screw' });
                break;

            case isEqual(index, 5):
                router.push({ path: '/centering-rings' });
                break;

            case isEqual(index, 6):
                router.push({ path: '/about' });
                break;

            case isEqual(index, 7):
                router.push({ path: '/screw' });
                break;

            case isEqual(index, 8):
                router.push({ path: '/auto-cases' });
                break;

            case isEqual(index, 9):
                router.push({ path: '/cargo-tires' });
                break;

            case isEqual(index, 10):
                router.push({ path: '/personal' });
                break;

            case isEqual(index, 11):
                router.push({ path: '/orders-history' });
                break;

            case isEqual(index, 12):
                this.logout();
                break;
        }

        if ([10, 11, 12].includes(index)) this.accountMenuModel = !this.accountMenuModel;
    }

    // handleGoodsMenuItem(index: number): void {
    //   switch (true) {
    //     case isEqual(index, 0): router.push({ path: '/centering-rings' });
    //     break;

    //     case isEqual(index, 1): router.push({ path: '/screw' });
    //     break;

    //     case isEqual(index, 2): router.push({ path: '/auto-cases' });
    //     break;

    //     case isEqual(index, 3): router.push({ path: '/auto-mats' });
    //     break;
    //   }
    // }

    handleCatalogItem(index: number): void {
        switch (true) {
            case isEqual(index, 0):
                router.push({ path: '/tires-view' });
                break;

            case isEqual(index, 1):
                router.push({ path: '/cargo-tires' });
                break;

            case isEqual(index, 2):
                router.push({ path: '/wheel-disks' });
                break;

            case isEqual(index, 3):
                router.push({ path: '/accumulator-batteries' });
                break;

            case isEqual(index, 4):
                router.push({ path: '/centering-rings' });
                break;

            case isEqual(index, 5):
                router.push({ path: '/screw' });
                break;

            case isEqual(index, 6):
                router.push({ path: '/auto-cases' });
                break;

            case isEqual(index, 7):
                router.push({ path: '/auto-mats' });
                break;
        }
    }

    handleBuyerItem(index: number): void {
        let routerLink = '';

        switch (true) {
            case isEqual(index, 0):
                routerLink = '/how-to-buy';
                break;

            case isEqual(index, 1):
                routerLink = '/delivery';
                break;

            case isEqual(index, 2):
                routerLink = '/bonuses';
                break;

            case isEqual(index, 3):
                routerLink = '/guaranty';
                break;

            case isEqual(index, 4):
                routerLink = '/installment';
                break;
        }

        router.push({ path: routerLink });
    }

    handleMobileMenu(value: string): void {
        let routerLink = '';

        switch (true) {
            case isEqual(value, 'main'):
                routerLink = '/';
                break;

            case isEqual(value, 'tires'):
                routerLink = '/tires-view';
                break;

            case isEqual(value, 'wheels'):
                routerLink = '/wheel-disks';
                break;

            case isEqual(value, 'batteries'):
                routerLink = '/accumulator-batteries';
                break;

            case isEqual(value, 'rings'):
                routerLink = '/centering-rings';
                break;

            case isEqual(value, 'screw'):
                routerLink = '/screw';
                break;

            case isEqual(value, 'howBuy'):
                routerLink = '/how-to-buy';
                break;

            case isEqual(value, 'delivery'):
                routerLink = '/delivery';
                break;

            case isEqual(value, 'bonuses'):
                routerLink = '/bonuses';
                break;

            case isEqual(value, 'guarantee'):
                routerLink = '/guaranty';
                break;

            case isEqual(value, 'installment'):
                routerLink = '/installment';
                break;

            case isEqual(value, 'about'):
                routerLink = '/about';
                break;

            case isEqual(value, 'carMats'):
                routerLink = '/auto-mats';
                break;

            case isEqual(value, 'autoBags'):
                routerLink = '/auto-cases';
                break;

            case isEqual(value, 'cargo'):
                routerLink = '/cargo-tires';
                break;

            case isEqual(value, 'termsAgreement'):
                this.downloadDocument();
                break;
        }

        router.push({ path: routerLink });
    }

    showSecondMenu(condition: boolean): void {
        this.isHiddenSecondMenuContainer = condition;
    }

    setActiveTab(tab: string): void {
        this.activeTab = tab;
    }

    closeSnackbar(): void {
        store.dispatch('changeSnackbar', { status: false, text: '', isError: false });
    }

    toMainPage(): void {
        console.log('TO MAIN PAGE');

        router.push({ path: '/' });
    }

    toAboutPage(): void {
        router.push({ path: '/about' });
    }

    logout(): void {
        this.isSign = false;
        orderService.logout();
    }

    downloadDocument(): void {
        window.location.href = downloadTermsOfAgreementHref;
    }

    @Watch('storageToken')
    tokenObserver() {
        const decoded = storageService.decodeToken(this.storageToken);
        store.dispatch('setEmail', decoded ? (decoded as DecodedToken).email : '');
        if (decoded) this.isSign = true;
    }

    @Watch('isUnAuthorized')
    unAuthorizedObservable() {
        if (this.isUnAuthorized) {
            this.isSign = false;
            this.handleClick(false);
        }
    }
}
